/* import __COLOCATED_TEMPLATE__ from './pipeline-chart.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();